import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Chapter, Reveal } from "./Chapter";
import { FAQ_ITEMS } from "../lib/data";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 grain" data-testid="section-faq">
      <div className="max-w-4xl mx-auto">
        <Chapter num="8" label="Foire aux questions" />
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink">
            Préparez votre séjour,<br />
            <span className="italic font-medium text-pine">l'esprit léger.</span>
          </h2>
        </Reveal>

        <div className="mt-14 space-y-4">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={0.06 * i}>
                <div
                  className={`rounded-2xl border transition-colors duration-300 ${
                    isOpen ? "border-pine/40 bg-cream/80" : "border-ink/10 bg-cream/40"
                  }`}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 text-left px-6 py-5"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="font-display font-bold text-lg text-ink">{item.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`grid place-items-center w-9 h-9 shrink-0 rounded-full ${
                        isOpen ? "bg-pine text-sand" : "bg-ink/5 text-ink"
                      }`}
                    >
                      <Plus size={17} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-ink/65 leading-relaxed">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
